// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1lEbM","label":"Category_label__-P540","content":"Category_content__3ZdEl","header":"Category_header__3-Ttd","location":"Category_location__cruHX"};